import React, {useContext} from "react";
import {connect} from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";

import ErrorIcon from "@mui/icons-material/Error";
import IconButton from "@mui/material/IconButton";
import Button from "@mui/material/Button";
import CloseIcon from "@mui/icons-material/Close";

import LookAiPopupContext from "./LookAiPopupContext";
import {postGenerateLookAiImage} from "../../aiApi/aiApi";
import {setAIResults} from "../../aiActions";
import {getSignal, newController} from "../../aiApi/aiController";


const LookAIPopupDropZoneError = (props) => {

  const {aiLoading, aiResults, postGenerateLookAiImage, setAIResults, intl} = props;

  const {lookAiPopupContext} = useContext(LookAiPopupContext);

  if (aiLoading) {
    return null
  }

  const activeResult = aiResults.find(aiResult => aiResult.isActive);

  if (!activeResult) {
    return null
  }

  const disabled = aiLoading || !lookAiPopupContext.userFile || !lookAiPopupContext.groupObjects
    || !lookAiPopupContext.groupObjects.some(groupObject => groupObject.enabled);

  const retryButtonClick = () => {
    const controller = newController(); // replace the shared controller
    postGenerateLookAiImage(lookAiPopupContext, controller.signal ?? getSignal());
  }

  const closeErrorButtonClick = () => {
    setAIResults(aiResults.map(aiResult => {
      if (aiResult.isActive) {
        aiResult.conversionError = "";
      }
      return aiResult
    }))
  }

  return (
    <div className="flex flex--column flex--center u-w-full u-h-full u-pb-175 text-center">
      <IconButton aria-label={intl.formatMessage({id: "iconButton.close"})}
                  className="look-icon look-icon--small absolute u-right-025 u-top-025"
                  onClick={closeErrorButtonClick}>
        <CloseIcon/>
      </IconButton>
      <div className="look-ai__title u-leading-1 bold flex flex--center u-gap-025">
        <IconButton className="look-icon look-icon--small look-icon--yellow">
          <ErrorIcon/>
        </IconButton>
      </div>
      <span className="bold color-primary font--12 u-leading-1">
        {activeResult.conversionError}
      </span>
      <Button
        className={"absolute u-bottom-05 u-right-05 u-left-auto look-button look-button--half-radius look-button--no-transform look-button--small" +
          " look-button--yellow u-top-auto"}
        disabled={disabled}
        onClick={disabled ? null : retryButtonClick}>
        <FormattedMessage id="buttons.retry"/>
      </Button>
    </div>
  )
};

const mapStateToProps = (store) => {
  const {aiLoading, aiResults} = store.aiState;
  return {
    aiLoading,
    aiResults,
  };
};

const mapDispatchToProps = {
  postGenerateLookAiImage,
  setAIResults,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(LookAIPopupDropZoneError)
)
